import axios from "axios";
import {
    CREATE_NEWS_REQUEST,
    CREATE_NEWS_SUCCESS,
    CREATE_NEWS_FAIL,

    
    GET_ALL_NEWS_REQUEST,
    GET_ALL_NEWS_SUCCESS,
    GET_ALL_NEWS_FAIL,

    UPDATE_NEWS_REQUEST,
    UPDATE_NEWS_SUCCESS,
    UPDATE_NEWS_FAIL,

    DELETE_NEWS_REQUEST,
    DELETE_NEWS_SUCCESS,
    DELETE_NEWS_FAIL,

    RECOVER_NEWS_REQUEST,
    RECOVER_NEWS_SUCCESS,
    RECOVER_NEWS_FAIL,
    CLEAR_ERROR,

} from '../constants/newsConstant'

import {host} from "../../utils/config";



export const createNews = (details) => async (dispatch) => {

    try {
        // console.log("create member")

        dispatch({ type: CREATE_NEWS_REQUEST });
        const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

        const data = await axios.post(`${host}/web/api/v1/new/news`, details, config);

        dispatch({ type: CREATE_NEWS_SUCCESS, payload: data.data });

    } catch (error) {
        dispatch({
            type: CREATE_NEWS_FAIL,
            payload: error.response.data.message,
        });
    }
};

export const getAllNews = () => async (dispatch) => {
    try {
        dispatch({ type: GET_ALL_NEWS_REQUEST });
        const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

        const {data} = await axios.get(`${host}/web/api/v1/news`, config);

        dispatch({ type: GET_ALL_NEWS_SUCCESS, payload: data });

    } catch (error) {
        dispatch({
            type: GET_ALL_NEWS_FAIL,
            payload: error.response.data.message,
        });
    }
};


export const updateNews = (details,id) => async (dispatch) => {
    try {

        dispatch({ type: UPDATE_NEWS_REQUEST });
        const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

        const {data} = await axios.put(`${host}/web/api/v1/update/news/${id}`, details, config);

        dispatch({ type: UPDATE_NEWS_SUCCESS, payload: data.success });


    } catch (error) {
        dispatch({
            type: UPDATE_NEWS_FAIL,
            payload: error.response.data.message,
        });
    }
};

export const deleteNews = (id) => async (dispatch) => {
    try {

        dispatch({ type: DELETE_NEWS_REQUEST });
        const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

        const {data} = await axios.put(`${host}/web/api/v1/delete/news/${id}`,{}, config);

        dispatch({ type: DELETE_NEWS_SUCCESS, payload: data.success });


    } catch (error) {
        dispatch({
            type: DELETE_NEWS_FAIL,
            payload: error.response.data.message,
        });
    }
};

export const recoverNews = (id) => async (dispatch) => {
    try {

        dispatch({ type: RECOVER_NEWS_REQUEST });
        const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

        const {data} = await axios.put(`${host}/web/api/v1/recover/news/${id}`,{}, config);

        dispatch({ type: RECOVER_NEWS_SUCCESS, payload: data.success });

    } catch (error) {
        dispatch({
            type: RECOVER_NEWS_FAIL,
            payload: error.response.data.message,
        });
    }
};




export const clearError = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERROR });
};

